import { Component, Input, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { NbMenuService, NbSidebarService, NbPopoverDirective, NbDialogService } from '@nebular/theme';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAuth from '@app-stores/reducers/auth';
import * as Auth from '@app-stores/actions/auth.action';
import { UserData } from '../../../@core/data/users';
import { AnalyticsService } from '../../../@core/utils';
import { LayoutService } from '../../../@core/utils';
import { AppService } from '@app-services/app.service';
import { Router } from '@angular/router';
import { NotificationsService } from '../../../services/notifications.service';
import { TranslationService } from "../../../services/translation.service";
import * as moment from 'moment';
import { SeekersService } from '../../../pages/seekers/seekers.service';
import { NavigationService } from '@app-services/navigation.service';


@Component({
	selector: 'ngx-header',
	styleUrls: ['./header.component.scss'],
	templateUrl: './header.component.html',
})

export class HeaderComponent implements OnInit, OnDestroy {

	@Input() position = 'normal';
	@ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

	user: any;
	crmUser: any;
	userMenu: any = [
		{ title: 'Profile', link: '/pages/crm-users/crm-profile' },
		{ title: 'Change Password', link: '/auth/reset-password' },
		{ title: 'Log out' },
	];
	notification: { admin_uuid: string, user_uuid: string, notification_uuid: string, name: string, title: string, type: string, time: string }[] = [
	];
	// Private
	private _viewInited: boolean = false;
	private _unsubscribeAll: Subject<any>;

	public adminOmMessageUnreadCount: Number = 0;
	public adminMessageUnreadCount: Number = 0;

	constructor(
		private navigation: NavigationService,
		private sidebarService: NbSidebarService,
		private menuService: NbMenuService,
		private userService: UserData,
		private analyticsService: AnalyticsService,
		private layoutService: LayoutService,
		private _appService: AppService,
		private _store: Store<fromAuth.AuthState>,
		private _router: Router,
		private _notificationsService: NotificationsService,
		private _translationService: TranslationService,
		private dialogService: NbDialogService
	) {
		this._unsubscribeAll = new Subject();
		this.userMenu = this.userMenu.map(item => {
			const phraseKey = `Menu.${item.title.replace(/ /g, '')}`;
			item.title = this._translationService.translate(phraseKey);
			return item;
		});

		this.menuService.onItemClick().subscribe((e) => {
			if (e.item.hasOwnProperty('badge')) {
				e.item.badge.text = '';
				e.item.badge.status = null;
			}
			this.onMenuSelect(e);
		});
		this.menuService.onSubmenuToggle().subscribe((e) => {
			if (e.item.hasOwnProperty('badge')) {
				e.item.badge.text = '';
				e.item.badge.status = null;
			}
		});
	}

	ngOnInit() {
		this.getNotifications();
		setInterval(() => {this.getNotifications();}, (60*1000));
		this._appService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
			if (res) {
				this.crmUser = res;
			} else {
				this.crmUser = JSON.parse(localStorage.getItem('user'));
			}

			this.adminOmMessageUnreadCount = this.crmUser.totalOmMessages;
			this.adminMessageUnreadCount = this.crmUser.totalAdminMessages;
		});
		this._appService.setAdminOmMessageUnreadSub.subscribe(unreadCount => {
			this.adminOmMessageUnreadCount = unreadCount;
		});
		this._appService.setAdminMessageUnreadSub.subscribe(unreadCount => {
			this.adminMessageUnreadCount = unreadCount;
		});
	}

	back(): void {
		this.navigation.back()
	  }

	getNotifications() {
		this._notificationsService.getAllNotifications()
			.subscribe(
				(res) => {
					let response = res.data;
					if (this.crmUser.user_role == 'Application Processor') {
						response = response.filter(u => (u.type == 'appreview_notification'));
					} else {
						response = response.filter(u => (u.type != 'appreview_notification'));
					}
					this.notification = [];
					response.forEach((res2, index) => {

						let title = res2.data.body;
						const newOmMessageStartsWith = 'You have a new message from an OM';
						if (title === 'You have a new message from your OM' || title.indexOf(newOmMessageStartsWith) > -1) {
							title = this._translationService.translate('Common.Please see CRM - You have a new message from an OM') + ' - ' + res2.sender_name;
						}
						this.notification.push({ admin_uuid: res2.receiver_uuid, user_uuid: res2.sender_uuid, notification_uuid: res2.uuid, name: res2.sender_name, title, type: res2.type, time: moment(res2.created_at).fromNow() });
					});
				},
				(err) => {
				});
	}

	toggleSidebar(): boolean {
		this.sidebarService.toggle(true, 'menu-sidebar');
		this.layoutService.changeLayoutSize();

		return false;
	}

	goToHome() {
		this.menuService.navigateHome();
	}

	onMenuSelect(e) {
		const logoutPhrase = this._translationService.translate('Menu.Logout');
		switch (e.item.title) {
			case logoutPhrase:
				this._store.dispatch(new Auth.Logout());
				break;
		}
	}

	startSearch() {
		this.analyticsService.trackEvent('startSearch');
	}

	goToNotifications() {
		this._router.navigate(['/pages/crm-notification']);
	}

	hideNotificationsBell(){
		this.popover.hide();
	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	clearAllNotifications(dialog){
		this.dialogService.open(dialog, {
			context: {
				title: this._translationService.translate('Menu.Notifications'),
				text: this._translationService.translate('Menu.ClearNotificationsConfirm'),
				clear: () => {
					this._notificationsService.clearNotifications()
						.subscribe(
							(res) => {
								this.notification = [];
								this._notificationsService.notificationsRemoved(true);
							},
							(err) => {
								console.log(err);
							});
				}
			}
		});
	}
}
